import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

// material-ui
import { Grid, Box, Divider, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/PopularCard';

// icons
import { IconBrandEdge, IconBrandFacebook, IconCircleCheckFilled, IconBrandWhatsapp } from '@tabler/icons-react';

// ==============================|| DASHBOARD DEFAULT - Social CARD ||============================== //

const Social = ({ isLoading }) => {
    return (
        <>
            {isLoading ? (
                <SkeletonPopularCard />
            ) : (
                <MainCard content={false} sx={{ mb: 2, p: 2 }}>
                    <Typography variant="h3" color="inherit" align="center" sx={{ my: 2 }}>
                        وجوهات در شبکه‌های اجتماعی
                    </Typography>
                    <Grid container rowSpacing={1} alignItems="start" justifyContent="start" sx={{ p: 2 }}>
                        <Grid item color="gray">
                            <Typography variant="h4" color="inherit" sx={{ my: 1 }}>
                                ایتا:
                            </Typography>
                            <Typography variant="subtitle1" color="inherit" sx={{ mt: 1, display: 'flex' }}>
                                <IconBrandEdge />
                                <span dir="ltr"> +98 930 830 7410 </span>
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="h4" color="inherit" sx={{ my: 1 }}>
                                بله:
                            </Typography>
                            <Typography variant="subtitle1" color="inherit" sx={{ mt: '1', display: 'flex' }}>
                                <IconCircleCheckFilled />
                                <span dir="ltr"> +98 930 830 7410 </span>
                            </Typography>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="h4" color="inherit" sx={{ my: 1 }}>
                                فیس بوک:
                            </Typography>
                            <Typography variant="subtitle1" color="inherit" sx={{ mt: '1', display: 'flex' }}>
                                <IconBrandFacebook />
                                 facebook.com/sahmain
                            </Typography>
                            <br />
                        </Grid>
                    </Grid>
                </MainCard>
            )}
        </>
    );
};

Social.propTypes = {
    isLoading: PropTypes.bool
};

export default Social;
